import {
    Instance,
    Knot,
    Objekt,
    pluck,
    TableCalculation,
} from '@siposdani87/sui-js';
import { app } from '../app';
import { AdminService } from './adminService';
import { AssetService } from './assetService';
import { LanguageService } from './languageService';

export class AdminChamberService extends AdminService {
    static readonly inject = ['instances', 'languageService', 'assetService'];

    constructor(
        instances: Instance,
        $languageService: LanguageService,
        $assetService: AssetService,
    ) {
        super(
            'chamber-chambers-name',
            instances,
            $languageService,
            $assetService,
        );
    }

    getTableOptions(): object {
        return {
            no_content: {
                image_url: this.assetService.getPath(
                    'images/others/no-content.png',
                ),
                text: this.languageService.translate('text.no_content'),
            },
            sort: {
                column: 'created_at',
                order: 'desc',
            },
            row_count: 12,
            column: 'name',
            columns: [
                'logo',
                'name',
                'country.name',
                'parent.name',
                'children',
                'organizations',
                'actions',
            ],
            sorted: ['name:asc', 'created_at', 'active:asc'],
            calculations: this.getTableCalculations(),
        };
    }

    getTableFields(): string {
        return 'id,logo,name,country.name,organizations.name,parent.name,children.name';
    }

    getTableCalculations(): TableCalculation {
        return {
            logo: (chamber) => {
                const imageWrapper = new Knot('div');
                imageWrapper.addClass('img-wrapper');
                const imageKnot = new Knot('img');
                imageKnot.addClass('img-responsive');
                const defaultSrc = chamber.get<string>('logo.thumb.url');
                imageKnot.setAttribute('src', defaultSrc);
                imageWrapper.appendChild(imageKnot);
                return imageWrapper;
            },
            children: (chamber) => {
                return pluck(
                    chamber.get<Objekt[]>('children', []),
                    'name',
                ).join(', ');
            },
            organizations: (chamber) => {
                return pluck(
                    chamber.get<Objekt[]>('organizations', []),
                    'name',
                ).join(', ');
            },
        };
    }
}

export const adminChamberService = app.service('adminChamberService', AdminChamberService);
